import { ComprasEUnmatchedAuthor } from '../../types';
import { parseReaisToCents } from '../projectCosts/utils';

export const inferIsThirdPartyFromCompanyName = (companyName?: string | null): boolean => (
  !String(companyName || '').toLowerCase().includes('petronect')
);

export const unmatchedAuthorKey = (author: Pick<ComprasEUnmatchedAuthor, 'jira_account_id' | 'jira_display_name'>): string => (
  String(author.jira_account_id || '').trim() || author.jira_display_name
);

export type ComprasEUnmatchedCollaboratorForm = {
  name: string;
  email: string;
  companyId: string;
  roleId: string;
  hourlyRateOverride: string;
  isThirdParty: boolean;
};

export type ComprasEUnmatchedCollaboratorPayload = {
  name: string;
  email: string | null;
  jira_account_id: string;
  jira_display_name: string;
  company_id: number;
  role_id: number | null;
  hourly_rate_override: number | null;
  is_third_party: boolean;
};

export type ComprasEUnmatchedCollaboratorBuildResult =
  | { ok: true; payload: ComprasEUnmatchedCollaboratorPayload }
  | { ok: false; error: 'missing_account_id' | 'invalid_override' | 'missing_company' };

export const buildComprasEUnmatchedCollaboratorPayload = (
  author: ComprasEUnmatchedAuthor,
  form: ComprasEUnmatchedCollaboratorForm,
): ComprasEUnmatchedCollaboratorBuildResult => {
  const accountId = String(author.jira_account_id || '').trim();
  if (!accountId) {
    return { ok: false, error: 'missing_account_id' };
  }
  if (!String(form.companyId || '').trim()) {
    return { ok: false, error: 'missing_company' };
  }
  const overrideRate = parseReaisToCents(form.hourlyRateOverride);
  if (form.hourlyRateOverride.trim() && overrideRate == null) {
    return { ok: false, error: 'invalid_override' };
  }
  return {
    ok: true,
    payload: {
      name: form.name.trim() || author.jira_display_name,
      email: form.email.trim() || null,
      jira_account_id: accountId,
      jira_display_name: author.jira_display_name,
      company_id: Number(form.companyId),
      role_id: form.roleId ? Number(form.roleId) : null,
      hourly_rate_override: overrideRate,
      is_third_party: form.isThirdParty,
    },
  };
};
